import { render, staticRenderFns } from "./HighlightIconFocus.vue?vue&type=template&id=9ed05572&"
import script from "./HighlightIconFocus.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HighlightIconFocus.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports